'use client';

import { FileText, Download } from 'lucide-react';

interface TaxDocument {
  id: number;
  documentType: string;
  displayName: string;
  fileName?: string | null;
  filePath?: string | null;
  isActive: boolean;
  updatedAt: Date;
}

interface TaxDocumentConfig {
  id: string;
  title: string;
  description: string;
}

interface TaxDocumentsClientProps {
  documents: TaxDocument[];
  documentConfigs: TaxDocumentConfig[];
}

export default function TaxDocumentsClient({ documents, documentConfigs }: TaxDocumentsClientProps) {
  const handleViewDocument = (documentType: string) => {
    // Open PDF in new tab with clean URL
    const url = `/api/tax-documents/${documentType}`;
    window.open(url, '_blank');
  };

  return (
    <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
      {documentConfigs.map((config) => {
        const documentData = documents.find((d) => d.documentType === config.id);
        const isAvailable = documentData && documentData.isActive;
        
        return (
          <div key={config.id} className="bg-white rounded-lg shadow-sm border border-gray-100 p-6 hover:shadow-md transition-shadow flex flex-col h-full">
            <div className="flex items-start mb-4 flex-1">
              <div className="p-2 bg-brand-primary/10 rounded-lg mr-3">
                <FileText className="h-6 w-6 text-brand-primary" />
              </div>
              <div className="flex-1 min-w-0">
                <h3 className="text-lg font-semibold text-gray-900 mb-2 leading-tight">
                  {config.title}
                </h3>
                <p className="text-sm text-gray-600">
                  {config.description}
                </p>
              </div>
            </div>
            
            <div className="mt-auto">
              {documentData && (
                <p className="text-xs text-gray-400 mb-3 text-center">
                  Actualizado: {documentData.updatedAt instanceof Date
                    ? documentData.updatedAt.toLocaleDateString('es-ES')
                    : new Date(documentData.updatedAt).toLocaleDateString('es-ES')}
                </p>
              )}
              
              {isAvailable ? (
                <button
                  onClick={() => handleViewDocument(config.id)}
                  className="w-full flex items-center justify-center px-4 py-2 bg-brand-primary text-white rounded-md hover:bg-brand-primary-dark transition-colors"
                >
                  <Download className="h-4 w-4 mr-2" />
                  Ver Documento
                </button>
              ) : (
                <button
                  disabled
                  className="w-full flex items-center justify-center px-4 py-2 bg-gray-200 text-gray-500 rounded-md cursor-not-allowed"
                >
                  <FileText className="h-4 w-4 mr-2" />
                  No disponible
                </button>
              )}
            </div>
          </div>
        );
      })}
    </div>
  );
}